export default __webpack_public_path__ + "static/MediaContentSeven-26481d8dc5658469b3768088573e7d42.webp";